import { render, staticRenderFns } from "./StoryMitVRZurBootsmesse.vue?vue&type=template&id=6ca061bd&"
import script from "./StoryMitVRZurBootsmesse.vue?vue&type=script&lang=js&"
export * from "./StoryMitVRZurBootsmesse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports